export class BaseDateRequest {
  isDateActive?: Boolean;
  startDate?: Date;
  endDate?: Date;
}
